import { createSlice } from '@reduxjs/toolkit';

import { AppUser, AppUserRole, ModulePermissions } from 'types';
import APP_CONST from 'const/app-const';
// interface AccessRights {
//     permiss: ModulePermissions;
// }

const DEFAULT_ACCOUNT_STATE = {
    companyName: '',
    accountHash: '',
    accountSecret: '',
    isActive: false,
    platform: 'ac',
    version: 'v1',
    project: '',
    isExpired: false,
    accountEnvironment: 'production' as string,
    isDemo: false
};
const DEFAULT_USER_STATE = {
    email: '',
    userName: '',
    firstName: '',
    lastName: '',
    isActive: false,
    isAdmin: false,
    mobileNo: '',
    remark: '',
    createdAt: null,
    updatedAt: null,

    token: '',
    exp: 0,
    defaultAccount: 0,
    defaultRole: null
};
const DEFAULT_ROLES_STATE: AppUserRole[] = [];
const DEFAULT_PERMISSION_STATE: any = {};
const DEFAULT_PREFERENCE_STATE: any = {};
const DEFAULT_SETTING_STATE: any = {};
export const appDataSlice = createSlice({
    name: 'appData',
    initialState: {
        user: DEFAULT_USER_STATE,
        account: DEFAULT_ACCOUNT_STATE,
        roles: DEFAULT_ROLES_STATE,
        permission: DEFAULT_PERMISSION_STATE,
        preference: DEFAULT_PREFERENCE_STATE,
        setting: DEFAULT_SETTING_STATE
    },
    reducers: {
        updateAppAccount: (state, action) => {
            state.account = { ...state.account, ...action.payload }
            localStorage.setItem(APP_CONST.KEY_STORE_ACC, JSON.stringify(state.account));
        },
        cleanAppAccount: (state) => {
            state.account = { ...DEFAULT_ACCOUNT_STATE }
            localStorage.setItem(APP_CONST.KEY_STORE_ACC, JSON.stringify(state.account));
        },
        updateAppUser: (state, action) => {
            state.user = { ...state.user, ...action.payload }
            localStorage.setItem(APP_CONST.KEY_STORE_USER, JSON.stringify(state.user));
        },
        cleanAppUser: (state) => {
            state.user = { ...DEFAULT_USER_STATE };
            localStorage.setItem(APP_CONST.KEY_STORE_USER, JSON.stringify(state.user));
        },
        updateAppUserRole: (state, action) => {

            state.roles = [...action.payload];
            localStorage.setItem(APP_CONST.KEY_STORE_ROLES, JSON.stringify(state.roles));
        },
        updateAppPermission: (state, action) => {

            state.permission = { ...action.payload };
            localStorage.setItem(APP_CONST.KEY_STORE_PERMISSION, JSON.stringify(state.permission));
        },
        updateAppAggregatedPermission: (state, action) => {
            if (action.payload) {
                localStorage.setItem(APP_CONST.KEY_STORE_AGGREGATED_PERMISSION, JSON.stringify(action.payload));
            } else {
                localStorage.removeItem(APP_CONST.KEY_STORE_AGGREGATED_PERMISSION);
            }
        },
        updatePreference: (state, action) => {

            state.preference = { ...action.payload };
            localStorage.setItem(APP_CONST.KEY_STORE_PREFERENCE, JSON.stringify(state.preference));
        },
        updateSetting: (state, action) => {

            state.setting = { ...action.payload };
            localStorage.setItem(APP_CONST.KEY_STORE_SETTING, JSON.stringify(state.setting));
        },
        updateAppData: (state, action) => {
            state = {
                user: { ...state.user, ...action.payload.user },
                account: { ...state.account, ...action.payload.account },
                roles: [...action.payload.roles],
                permission: { ...action.payload.permission },
                preference: { ...action.payload.preference },
                setting: { ...action.payload.setting }
            }

            localStorage.setItem(APP_CONST.KEY_STORE_USER, JSON.stringify(state.user));
            localStorage.setItem(APP_CONST.KEY_STORE_ACC, JSON.stringify(state.account));
            localStorage.setItem(APP_CONST.KEY_STORE_ROLES, JSON.stringify(state.roles));
            localStorage.setItem(APP_CONST.KEY_STORE_PERMISSION, JSON.stringify(state.permission));
            localStorage.setItem(APP_CONST.KEY_STORE_PREFERENCE, JSON.stringify(state.preference));
            localStorage.setItem(APP_CONST.KEY_STORE_SETTING, JSON.stringify(state.setting));
            return state;
        },
        cleanAppData: (state) => {
            state = {
                user: { ...DEFAULT_USER_STATE },
                account: { ...DEFAULT_ACCOUNT_STATE },
                roles: [...DEFAULT_ROLES_STATE],
                permission: { ...DEFAULT_PERMISSION_STATE },
                preference: { ...DEFAULT_PREFERENCE_STATE },
                setting: { ...DEFAULT_SETTING_STATE }
            }

            localStorage.setItem(APP_CONST.KEY_STORE_USER, JSON.stringify(state.user));
            localStorage.setItem(APP_CONST.KEY_STORE_ACC, JSON.stringify(state.account));
            localStorage.setItem(APP_CONST.KEY_STORE_ROLES, JSON.stringify(state.roles));
            localStorage.setItem(APP_CONST.KEY_STORE_PERMISSION, JSON.stringify(state.permission));
            localStorage.setItem(APP_CONST.KEY_STORE_PREFERENCE, JSON.stringify(state.preference));
            localStorage.setItem(APP_CONST.KEY_STORE_SETTING, JSON.stringify(state.setting));
            return state;
        }
    }
});
export const {
    updateAppAccount, cleanAppAccount,
    updateAppUser, cleanAppUser,
    updateAppUserRole, updateAppPermission, updateAppAggregatedPermission,
    updatePreference, updateSetting,
    updateAppData, cleanAppData
} = appDataSlice.actions;
export default appDataSlice.reducer;